// Real customer reference photos provided by the user (locally hosted)
export const HERO_BG = "/images/hero-garage.png";

export const LOGO_URL = "/images/logo.png";

export const REFERENCES = [
  {
    title: "Antracit dupla garázs fehér kapuval",
    location: "Kivitelezett projekt, 2025",
    meta: "Antracit + fehér szegő · Lapostető · Szekcionált kapu · Bejárati ajtó",
    category: "nagy",
    img: "/images/ref-4-aranytolgy.jpg",
  },
  {
    title: "Világos dupla garázs pulttetővel",
    location: "Kivitelezett projekt, 2025",
    meta: "Fehér panel · Pulttető · Szekcionált kapu · Modern kialakítás",
    category: "nagy",
    img: "/images/ref-3-kicsi-feher.jpg",
  },
  {
    title: "Fehér tároló fekete szegéllyel",
    location: "Kivitelezett projekt, 2025",
    meta: "Fehér + fekete szegő · Pulttető · Kompakt tároló ablakkal",
    category: "kicsi",
    img: "/images/ref-2-feher-pult.webp",
  },
  {
    title: "Aranytölgy melléképület",
    location: "Kivitelezett projekt, 2025",
    meta: "Aranytölgy panel · Pulttető · Kétszárnyú nyíló · Ablakkal",
    category: "kozepes",
    img: "/images/ref-1-antracit.jpg",
  },
];
